export default {
  dotia: {
    name: "dotia",
    basic: {
      default: "#376bae",
      font: "#fff",
      darkMode: "#8cb7ef"
    },
    button: {
      default: "#376bae",
      font: "#fff",
      darkMode: "#8cb7ef"
    },
    soft_basic: {
      default: "#9bb5d6",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    logo: "/static/img/brands/dotia/logo.svg",
    logocolor: "/static/img/brands/dotia/logo-color.svg",
    logodarkmode: "/static/img/brands/dotia/logo.svg",
    logoSize: "small",
    background: "/static/img/brands/dotia/background.jpg",
    footer: {
      es: {
        textos: ["Dotia © 2021"]
      }
    },

    fonts: {
      link: "family=Lato:400,500,700",
      principal: "'Lato', sans-serif",
      secundaria: "'Lato', sans-serif"
    },

    logintexts: {
      es: {
        antiguos: "Antiguos Alumnos",
        estudiantes: "Estudiantes",
        empresas: "Empresas"
      }
    },

    //CV DEL USUARIO
    quitarCampoDiscapacidad: true,

    //REGISTRO DE LAS EMPRESAS
    registroEmpresas: {
      sede: {
        visible: true,
        required: true
      },
      dni: {
        visible: true,
        required: true
      }
    },

    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración"
        },
        showIn: ["Empleo"],
        required: true
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)",
        showIn: ["Practicas"]
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*"
          },
          Practicas: {
            es: "Descripción del puesto*"
          }
        }
      },
      experiencia: {
        showIn: ["Empleo"]
      },
      motivosexclusion: {
        showIn: ["Empleo", "Practicas"]
      }
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true
      },
      tareasDesarrollar: {
        label: "Tareas a desarrollar",
        required: true
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)"
      },
      tutorEmpresa: {
        titulacion: true
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: ["Practicas"]
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: true
    },

    academicos: {
      calificacion: {
        editable: true
      },
      centro: {
        editable: true
      }
    },

    personales: {
      imagen: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: false
      },
      emailestudiante: {
        visible: true,
        editable: false
      },
      telefono: {
        visible: true,
        editable: false
      },
      email: {
        visible: true,
        editable: true
      },
      emailComunicaciones: {
        visible: true,
        editable: true
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      fecha_nacimiento: {
        visible: true,
        editable: false
      }
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      }
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false
      }
    },

    interes: {}
  },
  uax: {
    name: "uax",
    dominio_produccion: "empleo.uax.es",
    basic: {
      default: "#004d91",
      darkMode: "#8cb7ef"
    },
    button: {
      default: "#eabd00",
      font: "#fff",
      darkMode: "#8cb7ef"
    },
    soft_basic: {
      default: "#9cb6d7",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    hasFavicon: true,
    logo: "/static/img/brands/uax/logo.svg",
    logocolor: "/static/img/brands/uax/logo-color.svg",
    logodarkmode: "/static/img/brands/uax/logo.svg",
    logoSize: "medium",
    background: "/static/img/brands/uax/background.jpg",
    inMantenimiento: false,
    analitycs: "UA-126614877-2",
    emailContacto: "gaop@uax.es",
    emailInscripcion: "gaop@uax.es",
    emailProblemas: "gaop@uax.es",
    footer: {
      es: {
        textos: [
          "2023© Universidad Alfonso X el Sabio. La Universidad de la empresa",
          "Campus de Villanueva de la Cañada. Avd. Universidad, 1 Madrid. Teléfono 91 810 93 00"
        ],
        links: {
          "Aviso Legal": "https://gaop.uax.es/aviso-legal.html",
          "Política de privacidad":
            "https://gaop.uax.es/politica-privacidad.html",
          "Política de Cookies": "https://gaop.uax.es/politica-cookies.html"
        }
      }
    },
    fonts: {
      link: "family=Indie+Flower|Luckiest+Guy",
      principal: "'Arial', sans-serif",
      secundaria: "'Arial', sans-serif"
    },
    logintexts: {
      es: {
        antiguos: "Antiguos Alumnos",
        estudiantes: "Estudiantes",
        empresas: "Empresas"
      }
    },

    //CV DEL CANDIDATO
    quitarCampoDiscapacidad: true,

    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración"
        },
        showIn: ["Empleo"],
        required: true
      },
      ayudaEstudio: {
        label: {
          es: "Ayuda al estudio (€ brutos/mes)"
        },
        showIn: ["Practicas"]
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*"
          },
          Practicas: {
            es: "Descripción del puesto*"
          }
        }
      },
      experiencia: {
        showIn: ["Empleo"]
      },
      motivosexclusion: {
        showIn: ["Empleo", "Practicas"]
      }
    },

    //REGISTRO DE LAS EMPRESAS
    registroEmpresas: {
      sede: {
        visible: true,
        required: true
      },
      otrosector: {
        visible: false,
        required: false
      },
      dni: {
        visible: true,
        required: true
      }
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true
      },
      tareasDesarrollar: {
        label: "Tareas a desarrollar",
        required: true
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)"
      },
      tutorEmpresa: {
        titulacion: true,
        dni: true
      },

      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: ["Practicas"]
      },
      numeroDiasSemana: {
        label: "Número de días por semana",
        required: true
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: true
    },

    academicos: {
      calificacion: {
        editable: true
      },
      centro: {
        editable: true
      }
    },

    personales: {
      imagen: {
        visible: true,
        editable: true
      },
      emailComunicaciones: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: false
      },
      emailestudiante: {
        visible: true,
        editable: false
      },
      fecha_nacimiento: {
        visible: true,
        editable: false
      },
      telefono: {
        visible: true,
        editable: false
      },
      movil: {
        visible: true,
        editable: false
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      seleccionarEmailComunicaciones: {
        visible: true,
        editable: true
      },
      direcciones: {
        "1": {
          visible: true,
          editable: false,
          hide: []
        },
        "2": {
          visible: false,
          editable: false,
          hide: []
        }
      }
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      }
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false
      }
    },

    hashelp: "alumnos",

    interes: {},

    //PROPUESTA DE PRACTICAS
    instruccionesPropuestaPracticas:
      "/static/img/brands/uax/instrucciones-propuesta-de-practicas.pdf",
    showPropuestaPracticas: true,
    documentosPracticas: {
      url: "https://www.miotroseguro.com/"
    },

    //REGISTRO DE LOS ALUMNOS
    ownlogin: {
      hasEstudiante: true,
      hasEgresado: true,
      textoEstudiantes: {
        es:
          "Los estudiantes de UAX disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>"
      },
      textoEgresados: {
        es:
          "Los egresados de UAX disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>"
      }
    },

    checkMenuEducacion: true,
    maxLengthEncuestas: 256
  },
  comillas: {
    name: "comillas",
    basic: {
      default: "#303338",
      alternative: "#ffb81c",
      fontAlternative: "#202020",
      darkMode: "#8cb7ef"
    },
    button: {
      default: "#ffb81c",
      font: "#303338",
      darkMode: "#8cb7ef"
    },
    soft_basic: {
      default: "#97999b",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    hasFavicon: true,
    logo: "/static/img/brands/comillas/logo.svg",
    logocolor: "/static/img/brands/comillas/logo.svg",
    logodarkmode: "/static/img/brands/comillas/logo-white.svg",
    logoSize: "medium",
    background: "/static/img/brands/comillas/background.jpg",
    emailContacto: "oia@comillas.edu",
    emailInscripcion: "oia@comillas.edu",
    emailProblemas: "oia@comillas.edu",
    hideSAML: true,
    ownpopup_info: {
      editar_personales: {
        titulo: "Edición de datos personales",
        texto:
          "Si alguno de los datos no editables no es correcto, por favor, accede a tu intranet para modificarlos."
      }
    },
    footer: {
      es: {
        textos: [
          "© Universidad Pontificia Comillas",
          "C. Alberto Aguilera 23 Madrid-28015 - Tel.:<a href='tel:915422800'>(+34) 91 542 28 00</a> <a href='mailto:oia@comillas.edu'>oia@comillas.edu</a>"
        ],
        links: {
          "Aviso Legal": "https://www.comillas.edu/Documentos/Aviso_Legal.pdf",
          "Política de Cookies":
            "https://www.comillas.edu/es/politica-de-cookies",
          "Buzón de quejas, sugerencias y felicitaciones":
            "https://www.comillas.edu/es/unidad-de-calidad-y-prospectiva/sugerencias/buzon"
        }
      }
    },
    fonts: {
      link: "family=Muli:300,400,500,700,800",
      principal: "'Muli', sans-serif",
      secundaria: "'Muli', sans-serif"
    },
    ownstyles: "/static/img/brands/comillas/style.css",
    logintexts: {
      es: {
        antiguos: "Antiguos Alumnos",
        estudiantes: "Estudiantes",
        empresas: "Empresas"
      }
    },

    //PROPUESTA DE PRACTICAS
    instruccionesPropuestaPracticas: "",
    showPropuestaPracticas: true,

    //SETEO DE LAS OFERTAS
    requestEmpresaDestino: true,
    CVRequired: true,

    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración"
        },
        showIn: ["Practicas", "Empleo"],
        required: true
      },
      ayudaEstudio: {
        label: {
          es: "Ayuda al estudio (€ brutos/mes)"
        },
        showIn: ["Practicas"]
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true
      },
      empresaDestino: {
        showIn: ["Empleo", "Practicas"]
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*"
          },
          Practicas: {
            es: "Descripción del puesto*"
          }
        }
      },
      experiencia: {
        showIn: ["Empleo"]
      },
      motivosexclusion: {
        showIn: ["Empleo", "Practicas"]
      },
      paraEstudiantesUltimoCurso: {
        showIn: ["Practicas"]
      },
      modalidad: {
        showIn: ["Empleo", "Practicas"]
      },
      tipoContrato: {
        showIn: ["Empleo", "Practicas"]
      },
      urlInformacionComplementaria: {
        showIn: ["Empleo", "Practicas"]
      }
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true
      },
      tareasDesarrollar: {
        label: "Tareas a desarrollar",
        required: true
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)"
      },
      tutorEmpresa: {
        titulacion: true
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: ["Practicas"]
      },
      tipoPracticaCurriExtracurri: false,
      solicitudParaCentroEducativo: false
    },

    //REGISTRO DE LA EMPRESA
    requestStartUp: true,
    requestTipoEmpresa: true,
    requestDireccionFullContactoEmpresa: true,
    requestDireccionContactoEmpresa: true,
    registroEmpresas: {
      sede: {
        visible: false,
        required: false
      },
      dni: {
        visible: true,
        required: true
      }
    },

    //CV DEL CANDIDATO
    quitarCampoDiscapacidad: true,
    canEditPeriodoPracticas: true,

    personales: {
      imagen: {
        visible: true,
        editable: true
      },
      emailComunicaciones: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: true
      },
      fecha_nacimiento: {
        visible: true,
        editable: false
      },
      telefono: {
        visible: true,
        editable: false
      },
      movil: {
        visible: true,
        editable: false
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      direcciones: {
        "1": {
          visible: true,
          editable: false,
          hide: []
        },
        "2": {
          visible: false,
          editable: false,
          hide: []
        }
      }
    },

    academicos: {
      calificacion: {
        editable: true
      },
      centro: {
        editable: true
      }
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      }
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false
      }
    },

    interes: {},

    //DOCUMENTACIÓN DE EMPRESAS
    haveDocumentosPracticas: true
  },
  uc3m: {
    name: "uc3m",
    basic: {
      default: "#001D83",
      alternative: "#001D83",
      fontAlternative: "#202020",
      darkMode: "#8cb7ef"
    },
    button: {
      default: "#001D83",
      font: "#ffffff",
      darkMode: "#8cb7ef"
    },
    soft_basic: {
      default: "#7E8EC1",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    hasFavicon: true,
    logo: "/static/img/brands/uc3m/logo-b.svg",
    logocolor: "/static/img/brands/uc3m/logo-color.svg",
    logodarkmode: "/static/img/brands/uc3m/logo-b.svg",
    logoencabezado: "/static/img/brands/uc3m/logo-color.svg",
    logoSize: "big",
    background: "/static/img/brands/uc3m/background.jpg",
    emailContacto: "practicas@fund.uc3m.es",
    emailInscripcion: "practicas@fund.uc3m.es",
    emailProblemas: "practicas@fund.uc3m.es",
    footer: {
      es: {
        textos: ["", ""],
        links: {
          "Aviso Legal": "https://www.fundacion.uc3m.es/aviso-legal/",
          "Política de Cookies":
            "https://www.fundacion.uc3m.es/politica-de-cookies/",
          "Política de protección de datos personales":
            "https://www.fundacion.uc3m.es/politica-de-privacidad/"
        }
      }
    },
    fonts: {
      link: "family=Roboto:400,500,700",
      principal: "'Roboto', sans-serif",
      secundaria: "'Roboto', sans-serif"
    },
    ownstyles: "/static/img/brands/uc3m/style.css",
    logintexts: {
      es: {
        antiguos: "Antiguos Alumnos",
        estudiantes: "Estudiantes",
        empresas: "Empresas"
      }
    },

    canCambiarPracticas: true,
    busquedasGuardadas: true,
    buscarPorInicioPracticas: true,

    //PROPUESTA DE PRÁCTICAS
    showPropuestaPracticas: "isEmpresa",
    informacionAdicionalFacturacion: true,

    //SETEO DE LAS OFERTAS
    requestEmpresaDestino: true,
    CVRequired: false,
    canDuplicarOferta: true,
    canDuplicarOfertaInvertida: true,
    requestInfoSeleccionado: true,
    hasOFertasTFM: true,
    controlDetitulacionesPorTipo: true,
    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración"
        },
        showIn: ["Empleo"],
        required: false
      },
      ayudaEstudio: {
        label: {
          es: "Ayuda al estudio (€ brutos/mes)"
        },
        showIn: ["Practicas"]
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*"
          },
          Practicas: {
            es: "Objetivo formativo y contenido de las prácticas*"
          }
        }
      },
      otraFormacion: {
        label: "Otra formación",
        showIn: ["Empleo", "Practicas"],
        required: false
      },
      opcionesPublicacion: {
        showIn: ["Empleo", "Practicas"]
      },
      empresaDestino: {
        showIn: ["Empleo", "Practicas"]
      },
      experiencia: {
        showIn: ["Empleo"]
      }
    },

    //REGISTRO DE LA EMPRESA
    requestDireccionContactoEmpresa: true,
    requestTipoEmpresa: true,
    requestTipoContacto: true,
    hideRequestFirmanteRegistro: true,
    hideEmailMiEmpresa: true,
    registroEmpresas: {
      sede: {
        visible: false,
        required: false
      },
      dni: {
        visible: false,
        required: false
      },
      otrosector: {
        visible: true,
        required: true
      },
      mensajepersonalizado: {
        titulo: "¡Atención!",
        mensaje:
          "Si va a seleccionar candidatos/as en prácticas, deberá firmar un convenio de colaboración educativa con UC3M. Puede solicitarlo desde el menú Documentación.",
        to: "/login/empresas"
      }
    },

    //CV DEL CANDIDATO
    quitarCampoDiscapacidad: false,
    canEditPeriodoPracticas: false,
    checkIbanInPracticasConServicio: true,
    personales: {
      tipoDocumentoIdentidad: {
        visible: true,
        editable: false
      },
      documentoIdentidad: {
        visible: true,
        editable: false
      },
      emailestudiante: {
        visible: true,
        editable: false
      },
      imagen: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: true,
        required: true
      },
      telefono: {
        visible: true,
        editable: true
      },
      movil: {
        visible: true,
        editable: true,
        required: true
      },
      genero: {
        visible: true,
        editable: false,
        required: true
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      aceptaNewsletter: {
        visible: false,
        editable: false,
        required: false
      },
      fecha_nacimiento: {
        visible: true,
        editable: false,
        required: false
      },
      password: false,
      iban: {
        visible: true,
        editable: true
      },
      numeroSeguridadSocial: {
        visible: true,
        editable: true
      },
      idPaisNacionalidad: {
        visible: true,
        editable: false,
        required: true
      },
      direcciones: {
        "1": {
          visible: true,
          editable: true,
          hide: ["tipovia", "piso", "numero", "puerta"],
          nombre: {
            es: "Dirección actual"
          }
        },
        "2": {
          visible: true,
          editable: false,
          hide: ["tipovia", "piso", "numero", "puerta"],
          nombre: {
            es: "Dirección"
          }
        }
      },
      direccionsimple: {
        visible: false,
        editable: false
      }
    },

    academicos: {
      centro: {
        editable: true
      },
      nivelesEstudio: {
        editable: true
      },
      ramaTitulacion: {
        editable: true
      }
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto",
        required: true
      },
      tareasDesarrollar: {
        label: "Objetivo formativo/tareas",
        required: true
      },
      centropracticas: {
        label: "Dirección de realización de las prácticas",
        required: true
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)"
      },
      tutorEmpresa: {
        titulacion: false,
        telefono: true,
        cargo: true
      },
      direccion: false,
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: ["Practicas"]
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: true
    },

    hasPresentacion: true,

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      },
      enlace: {
        editable: true,
        validate: ""
      },
      adjunto: {
        editable: true,
        validate: ""
      }
    },

    profesionales: {
      intercambio: {
        editable: true,
        visible: true
      }
    },

    interes: {},

    ownlogin: {
      hasEstudiante: true,
      hasEgresado: true,
      textoEstudiantes: {
        es:
          "Los estudiantes de UC3M disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
      },
      textoEgresados: {
        es:
          "Los egresados de UC3M disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
      }
    },
    hasGuiasOrientacion: true,
    hasEventos: true,

    //DOCUMENTACION
    canSubirConvenios: true,
    tituloConvenios: "Convenios de Cooperación Educativa",
    canCrearConvenios: true,
    hasNotasFormativas: true,
    mensajeconveniogenerado: {
      titulo: "Convenio Generado",
      mensaje:
        "Por favor, revise el documento descargado.<br><br>En caso de ir a formalizar el documento con firma electrónica, para proceder a su formalización, es necesario que nos lo devuelvan con firma electrónica certificada haciendo clic en Subir Convenio Firmado.<br><br>Si tiene cualquier duda puede contactarnos en <a href='mailto:practicas@fund.uc3m.es'>practicas@fund.uc3m.es</a> o en el <a href='tel:916249902'>916249902</a>.<br><br>En caso de formalización en papel, rogamos remitan en papel dos ejemplares originales impresos a una sola cara y firmados con firma manuscrita original en todas sus páginas a:<br><br><strong>Fundación Universidad Carlos III</strong><br>Orientación & Empleo<br>Edif. Sabatini<br>Despacho 20 D 09<br>Avda. de la Universidad, 30<br>28911 Leganés (Madrid).<br><br>La vigencia del Convenio será la de la firma de la Universidad, por favor no registren fecha en el documento.<br><br>Si tiene cualquier duda puede contactar en <a href='mailto:practicas@fund.uc3m.es'>practicas@fund.uc3m.es</a> o en <a href='tel:916249902'>916249902</a>",
      to: "/documentacion"
    },
    mensajeconveniosubido: {
      titulo: "Convenio añadido correctamente",
      mensaje:
        "Cuando la Universidad haya firmado el Convenio le enviaremos copia final. La tramitación de Anexos de prácticas requiere que se haya completado el proceso de firma por lo que hasta ese momento ningún alumno debe incorporarse en prácticas a la empresa. Si tiene cualquier duda puede contactar en practicas@fund.uc3m.es o en 916249902"
    }
  },
  uva: {
    name: "uva",
    basic: {
      default: "#1e1e1e",
      alternative: "#e20049",
      fontAlternative: "#202020",
      darkMode: "#ffffff"
    },
    banner_home: {
      src: "/static/img/brands/uva/banner.png",
      link:
        "/programas-practicas-activos/xi-edicion-programa-de-formacion-de-gestores-de-i",
      internal: true
    },
    button: {
      default: "#e20049",
      font: "#ffffff",
      darkMode: "#ffffff"
    },
    soft_basic: {
      default: "#8E8E8E",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    hasFavicon: true,
    logo: "/static/img/brands/uva/logo-uva-white.png",
    logocolor: "/static/img/brands/uva/logo-uva-black.png",
    logoencabezado: "/static/img/brands/uva/logo-uva-black.png",
    logodarkmode: "/static/img/brands/uva/logo-uva-white.png",
    logoSize: "big",
    background: "/static/img/brands/uva/background.jpg",
    emailContacto: "funge@funge.uva.es",
    emailInscripcion: "funge@funge.uva.es",
    emailProblemas: "funge@funge.uva.es",
    analitycs: "UA-119874198-1",
    dominio_produccion: "portal.uvaempleo.com",
    portal_publico: "https://uvaempleo.com/",
    ownpopup_info: {
      uso_logo: {
        titulo: "Autorizo el uso de la imagen de la empresa",
        texto:
          "Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en el portal de candidatos/as y en la web pública de empleo de FUNGE UVa. Aunque autorices ahora, cuando crees ofertas podrás configurar si quieres que se muestren o no, vinculados a esa oferta, los datos de tu empresa."
      }
    },
    footer: {
      es: {
        textos: ["", ""],
        links: {
          "Aviso Legal": "https://funge.uva.es/aviso-legal/",
          "Política de Cookies": "https://funge.uva.es/politica-de-cookies/",
          "Política de privacidad": "https://funge.uva.es/proteccion-de-datos/"
        }
      }
    },
    fonts: {
      link: "family=Open%20Sans:400,500,700",
      principal: "'Open Sans', sans-serif",
      secundaria: "'Open Sans', sans-serif"
    },
    ownstyles: "/static/img/brands/uva/style.css",
    logintexts: {
      es: {
        antiguos: "Antiguos Alumnos",
        estudiantes: "Titulados",
        empresas: "Empresas"
      }
    },

    urlPortalTutores: "https://tutor.uvaempleo.com/",

    //PROPUESTA DE PRÁCTICAS
    instruccionesPropuestaPracticasEmpresas:
      "/static/img/brands/uva/instrucciones-propuesta-de-practicas-UVa.pdf",
    showPropuestaPracticas: "isEmpresa",
    requestProgramaPracticas: true,
    hasProgramaPracticasActivo: true,
    requestDatosFirmanteEnPropuesta: true,

    //SETEO DE LAS OFERTAS
    requestEmpresaDestino: true,
    CVRequired: false,
    canDuplicarOferta: true,
    canDeleteOferta: true,
    otrasRemuneracionesEnPracticas: true,
    hasAnyoMaximoPromocion: true,
    requestDatosFirmanteEnOferta: true,
    requestDatosTutorEnOferta: true,
    hideCamposTutor: [],
    hideOpcionesCandidatos: true,
    showMotivoRechazo: true,
    poblacionesDomain: true,
    tiempoDedicacionJornada: true,
    HistoricoOfertas: true,
    openTitulacionesSelector: true,
    ocultarEmpresaEnOferta: true,
    localidadesEnDominios: true,

    camposOferta: {
      tareas: {
        showIn: ["Practicas"]
      },
      otraRemuneracion: {
        label: {
          es: "Otros beneficios"
        },
        showIn: ["Practicas", "Empleo"],
        required: false
      },
      ayudaEstudio: {
        label: {
          es: "Beca mensual"
        },
        showIn: ["Practicas"]
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true
      },
      otraFormacion: {
        label: "Otra formación",
        showIn: ["Practicas"]
      },
      anyoMaximoPromocion: {
        label: "Año de promoción límite",
        showIn: ["Empleo"]
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*"
          },
          Practicas: {
            es: "Descripción del puesto*"
          }
        }
      },
      empresaDestino: {
        showIn: ["Empleo", "Practicas"]
      },
      experiencia: {
        showIn: ["Empleo"]
      },
      motivosexclusion: {
        showIn: ["Empleo", "Practicas"]
      }
    },

    camposPracticas: {
      tareasDesglosadas: true,
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true
      },
      tareasDesarrollar: {
        label: "Tareas a desarrollar",
        required: true
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false
      },
      otraRemuneracion: {
        label: {
          es: "Otros beneficios"
        },
        required: true
      },
      ayudaEstudio: {
        label: "Beca mensual",
        disabledHide: true
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: ["Practicas"]
      },
      tutorEmpresa: {
        cargo: true,
        departamento: true,
        telefono: true,
        titulacion: false
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: true
    },

    //REGISTRO DE LA EMPRESA
    requestDireccionContactoEmpresa: true,
    requestDireccionFullContactoEmpresa: true,
    requestDireccionFacturacion: true,
    requestTipoEmpresa: true,
    requestTipoContacto: true,
    hideRequestFirmanteRegistro: true,
    requestPerfilSectorial: true,
    checkDatosCompletosEmpresa: true,
    registroEmpresas: {
      sede: {
        visible: false,
        required: false
      },
      otrosector: {
        visible: false,
        required: false
      },
      dni: {
        visible: true,
        required: true
      }
    },

    //CV DEL CANDIDATO
    canEditDeLaUniversidad: true,
    quitarCampoDiscapacidad: true,
    estanciaenextranjero: true,
    hasDocumentacionLigadaProcesos: true,
    quitarCampoNotaAcademicos: true,
    formacionComplementaria: true,
    competenciasProfesionales: true,
    nivelesInformaticos: true,
    BornActive: true,
    popupDatosObligatorios: true,

    academicos: {
      nivelesEstudio: {
        editable: true
      },
      ramaTitulacion: {
        editable: true
      },
      certificado: {
        editable: true
      },
      horas: {
        editable: true
      },
      centro: {
        editable: true
      },
      nota: {
        editable: true
      }
    },

    personales: {
      tipoDocumentoIdentidad: {
        visible: true,
        editable: false
      },
      documentoIdentidad: {
        visible: true,
        editable: true
      },
      imagen: {
        visible: true,
        editable: true
      },
      nombre: {
        visible: true,
        editable: true,
        required: true
      },
      apellido1: {
        visible: true,
        editable: true,
        required: true
      },
      apellido2: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: true,
        required: true
      },
      telefono: {
        visible: true,
        editable: true
      },
      movil: {
        visible: true,
        editable: true,
        required: true
      },
      genero: {
        visible: true,
        editable: true,
        required: true
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      aceptaNewsletter: {
        visible: true,
        editable: true,
        required: true
      },
      fecha_nacimiento: {
        visible: true,
        editable: true,
        required: true
      },
      password: true,
      iban: {
        visible: true,
        editable: true
      },
      numeroSeguridadSocial: {
        visible: true,
        editable: true
      },
      idPaisNacionalidad: {
        visible: true,
        editable: true,
        required: true
      },
      idPaisNacimiento: {
        visible: true,
        editable: true,
        required: true
      },
      provinciaNacimiento: {
        visible: true,
        editable: true,
        required: true
      },
      lugarNacimiento: {
        visible: true,
        editable: true,
        required: true
      },
      direcciones: {
        "1": {
          visible: true,
          editable: true,
          hide: []
        },
        "2": {
          visible: true,
          editable: true,
          hide: []
        }
      }
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      },
      idTipoContrato: {
        editable: true,
        validate: "required"
      },
      idsubtipoContrato: {
        editable: true,
        validate: "required"
      },
      idActividadProfesional: {
        editable: true,
        validate: "required"
      },
      enlace: {
        editable: true,
        validate: ""
      },
      adjunto: {
        editable: true,
        validate: ""
      }
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false
      }
    },

    interes: {},

    //REGISTRO DE LOS ALUMNOS
    canRegistroAlumno: ["antiguos", "estudiantes", "alumnos"],
    OneLoginForCandidatos: true,
    hideSAML: true,
    canBorrarCuenta: true,
    checkDatosNecesariosEnLogin: true,
    canRecoveryPass: true,
    infoRGDP: true,

    //DOCUMENTACIÓN DE EMPRESAS
    hasDocumentacionPrivadaCV: true,
    canUploadDocEmpresas: true,
    literalAnexosFirmados: "Documentos firmados para prácticas asignadas",
    hideConveniosFirmados: true,
    haveDocumentosPrograma: true
  },
  uib: {
    name: "uib",
    dominio_produccion: "doipcandidats.fueib.org",
    basic: {
      default: "#709194",
      alternative: "#709194",
      darkMode: "#8cb7ef"
    },
    button: {
      default: "#709194",
      font: "#ffffff",
      darkMode: "#8cb7ef"
    },
    soft_basic: {
      default: "#BA4A40",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    hasFavicon: true,
    logo: "/static/img/brands/uib/logo-login.svg",
    logocolor: "/static/img/brands/uib/logo-color.svg",
    logoLogin: "/static/img/brands/uib/logo-login.svg",
    logoencabezado: "/static/img/brands/uib/logos-blanco.svg",
    logodarkmode: "/static/img/brands/uib/logos-blanco.svg",
    logoSize: "medium",
    background: "/static/img/brands/uib/background.jpg",
    emailContacto: "doip@fueib.org",
    emailProblemas: "doip@fueib.org",
    emailInscripcion: "inscripcio.ofertesdoip@fueib.org",
    analitycs: "UA-126614877-2",
    footer: {
      es: {
        textos: ["", ""],
        links: {
          "Aviso Legal": "https://fueib.org/ca/aviso_legal",
          "Política de Cookies": "https://fueib.org/ca/aviso_cookies",
          "Política de protección datos personales":
            "https://fueib.org/ca/politica_de_privacidad"
        }
      },
      ca: {
        textos: ["", ""],
        links: {
          "Avís legal": "https://fueib.org/ca/aviso_legal",
          "Política de Cookies": "https://fueib.org/ca/aviso_cookies",
          "Política de protecció dades personals":
            "https://fueib.org/ca/politica_de_privacidad"
        }
      }
    },
    fonts: {
      link: false,
      principal: "'uibsans', sans-serif",
      secundaria: "'uibsans', sans-serif"
    },
    ownstyles: "/static/img/brands/uib/style.css",
    logintexts: {
      es: {
        antiguos: "Otros perfiles demandantes de empleo",
        estudiantes: "Estudiantes UIB",
        empresas: "Empresas"
      },
      ca: {
        antiguos: "Altres perfils demandants d'ocupació",
        estudiantes: "Estudiants UIB",
        empresas: "Empreses"
      }
    },
    hideSAML: false,
    languagebydefault: "ca",
    ownFormLogin: ["antiguos"],

    requestDatosTutorEnOferta: true,
    hideCamposTutor: ["cargo", "telefono", "departamento"],

    dominios: [
      "tiposVia",
      "titulaciones",
      "ProgramasInformaticos",
      "competenciasfesionales",
      "tiposContacoEmpresa",
      "tipoMotivoCambioEstadoCandidatura",
      "tiposFormacionAcademica",
      "tiposDocumentoIdentidad",
      "tiposNivelesTitulacion",
      "ambitosEstudio",
      "numeroDeEmpleados",
      "TagsInteresAlumno",
      "rangosDeCreditos",
      "tiemposExperiencia",
      "tiposNivelFormativoSNE"
    ],

    //PROPUESTA DE PRÁCTICAS
    showPropuestaPracticas: false,

    //SETEO DE OFERTAS
    requestEmpresaDestino: true,
    CVRequired: false,
    requestDireccionContactoEmpresa: false,
    requestDireccionFullContactoEmpresa: false,
    requestTipoEmpresa: true,
    canDuplicarOferta: true,
    otrasRemuneracionesEnPracticas: true,
    canDeleteOferta: true,
    ocultarEmpresaEnOferta: true,
    requestDatosRealizacionPractica: true,
    filtradoenPracticas: true,
    ofertasqueencajan: true,
    filtradoporetiquetas: true,
    checkIbanInPracticas: true,
    showMotivoRechazo: true,
    checkIsla: true,
    showReferenciaOferta: true,
    hideOcultarRemuneracion: true,
    requestTutoresPractica: true,
    showDireccionEmpresa: true,
    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración",
          ca: "altra remuneració"
        },
        showIn: ["Empleo"],
        required: false,
        hideOcultar: true
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: false
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*",
            ca: "Descripció del lloc"
          },
          Practicas: {
            es: "Descripción del puesto*",
            ca: "Descripció del lloc"
          }
        }
      },
      candidatoPreferido: {
        label: {
          es: "Candidato/a preferido",
          ca: "Candidat/a preferit/da"
        },
        showIn: ["Practicas"]
      },
      empresaDestino: {
        showIn: ["Empleo"]
      },
      programasDeseables: {
        showIn: ["Practicas", "Empleo"]
      },
      experienciadeseable: {
        showIn: ["Empleo"]
      },
      experiencia: {
        showIn: ["Empleo"]
      },
      canIdiomaDeseable: true,
      requisitosfromcv: true,
      requisitosObligatorios: false,
      paraPerfilNoUniversitario: {
        showIn: ["Empleo"]
      },
      paraEstudiantesUltimoCurso: {
        showIn: ["Empleo"]
      },
      motivosexclusion: {
        showIn: ["Empleo", "Practicas"]
      },
      observacionespublicas: {
        showIn: ["Empleo", "Practicas"]
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: []
      },
      ayudaEstudio: {
        label: {
          es: "Beca mensual",
          ca: "Beca mensual"
        },
        popupinfo: "ayudaEstudioUIB",
        showIn: ["Practicas"],
        showrequired: true
      },
      horasDia: {
        popupinfo: "horasDiaUIB"
      }
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true
      },
      tareasDesarrollar: {
        label: "Tareas a desarrollar",
        required: true
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)",
        showIn: ["Practicas"]
      },

      tutorEmpresa: {
        titulacion: true
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada",
          ca: "Pràctica remunerada"
        },
        showIn: ["Practicas"]
      },
      okDeEmpresaParaValidar: {
        label: {
          es:
            "Enviar oferta para su revisión y, en su caso, publicación por DOIP",
          ca:
            "Enviar oferta a revisió i, si escau, publicació per part del DOIP"
        },
        showIn: ["Practicas", "Empleo"]
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: true
    },

    //REGISTRO DE LAS EMPRESAS
    requestTipoContacto: true,
    requestidiomaComunicacionContacto: true,

    registroEmpresas: {
      sede: {
        visible: false,
        required: false
      },
      iban: {
        visible: true,
        required: false
      },
      dni: {
        visible: true,
        required: true
      },
      numeroempleados: {
        visible: true,
        required: false
      },
      edicionimagen: {
        visible: true
      }
    },

    hidesedeperfil: true,
    hideEmailMiEmpresa: true,

    canRegistroAlumno: ["antiguos"],

    canRecoveryPass: true,

    textoRecoveryPass: {
      ca:
        "Si ets estudiant o egressat de la Universitat de les Illes Balears has d'anar a <a href='https://sso.uib.es/cas/login' target='_blank'>UIBdigital</a> per restablir o recuperar la contrasenya .",
      es:
        "Si eres estudiante o egresado de Universitat de les Illes Balears debes acudir a <a href='https://sso.uib.es/cas/login' target='_blank'>UIBdigital</a> para restablecer o recuperar tu contraseña."
    },
    logoutSSO: "https://sso.uib.es/cas/prelogout",

    controlCerrarOferta: true,
    camposcontrolCerrarOferta: [
      "inicioContrato",
      "candidatosSeleccionados",
      "idTipoCOntratoSNE"
    ],

    //CV DEL CANDIDATO
    quitarCampoDiscapacidad: false,
    canUploadDocEmpresas: true,
    hasDocumentacionPrivadaCV: true,
    hasDocumentacionLigadaProcesos: true,
    competenciasProfesionales: true,
    testCompetenciasProfesionales:
      "/encuestas/encuesta-competencias-transversales",
    validadoporellos: true,
    textvalidadoporellos: "alumno_validado_uib",
    ocultarAcademicos: true,
    hasNivelesFormacion: true,
    formacionComplementaria: true,
    personales: {
      imagen: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: true
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      tipoDocumentoIdentidad: {
        visible: false,
        editable: false
      },
      documentoIdentidad: {
        visible: true,
        editable: false
      },
      fecha_nacimiento: {
        visible: true,
        editable: true,
        required: true
      },
      genero: {
        visible: true,
        editable: true,
        required: true
      },
      emailestudiante: {
        visible: true,
        editable: true
      },
      password: true,
      movil: {
        visible: true,
        editable: true,
        required: true
      },
      telefono: {
        visible: true,
        editable: true
      },
      idIdiomaPreferido: {
        visible: true,
        editable: true
      },
      direcciones: {
        "1": {
          visible: false,
          editable: false,
          notas: false,
          hide: []
        },
        "2": {
          visible: true,
          editable: true,
          notas: true,
          isla: true,
          hide: ["piso", "puerta"]
        }
      },
      idPaisNacionalidad: {
        visible: true,
        editable: true,
        required: true
      },
      idPaisSegundaNacionalidad: {
        visible: true,
        editable: true,
        required: false
      },
      aceptaComunicacionesOrientacion: {
        visible: true,
        editable: true,
        required: false
      },
      direccionsimple: {
        visible: false,
        editable: false
      }
    },

    hasPresentacion: true,
    hascondicionespracticas: true,

    //REGISTRO DE LOS ALUMNOS
    ownlogin: {
      hasEstudiante: true,
      hasEgresado: false,
      textoEstudiantes: {
        es: "Accede con tus credenciales de UIBDigital",
        ca: "Accediu mitjançant el nom d’usuari d’UIBdigital"
      },
      botonEstudiantes: {
        es: "Acceso estudiantes UIB",
        ca: "Accés estudiants de la UIB"
      },
      botonEgresados: {
        es: "Acceso egresados UIB",
        ca: "Accés titulats/ades  de la UIB"
      },
      textoEgresados: {
        es:
          "Los egresados de UC3M disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
      },
      textoAyudaEgresados: {
        es:
          "Si todavía no te has registrado y eres egresado/a de UIB, debes también acceder con tus credenciales de UIBdigital para darte de alta en el servicio de DOIP. Puedes recuperar tus credenciales UIB <a href='https://sso.uib.es/cas/login' target='_blank'>aquí</a>.",
        ca:
          "Si encara no us heu registrat i sou titulat/ada de la UIB, també heu d'accedir amb les credencials d'UIBdigital per donar-vos d'alta al servei del DOIP. Podeu recuperar les credencials UIB <a href='https://sso.uib.es/cas/login' target='_blank'>aquí</a>."
      },
      linkpassword: "https://sso.uib.es/cas/login"
    },

    academicos: {
      calificacion: {
        editable: true
      },
      centro: {
        editable: true
      }
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      }
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false
      }
    },

    custommessage_busquedaactiva: "busquedaactivaempleo_uib",

    interes: {
      disponibilidadjornadas: {
        editable: true,
        visible: true
      },
      carnetMoto: {
        editable: true,
        visible: true
      },
      motoPropia: {
        editable: true,
        visible: true
      }
    }
  },
  upm: {
    name: "upm",
    languagebydefault: "es",
    basic: {
      default: "#376bae",
      font: "#fff",
      darkMode: "#8cb7ef"
    },
    button: {
      default: "#376bae",
      font: "#fff",
      darkMode: "#8cb7ef"
    },
    soft_basic: {
      default: "#9bb5d6",
      dark: "#9bb5d6"
    },
    text_black: {
      default: "#202020",
      darkMode: "#ffffff"
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3"
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4"
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c"
    },
    light_black: {
      default: "#f2f2f2",
      dark: "#333"
    },
    white: {
      default: "#fff",
      darkMode: "#222"
    },
    hasFavicon: true,
    logo: "/static/img/brands/upm/logo-login.svg",
    logocolor: "/static/img/brands/upm/logo-encabezado.svg",
    logodarkmode: "/static/img/brands/upm/logo-login.svg",
    logoSize: "big",
    logoencabezado: "/static/img/brands/upm/logo-encabezado.svg",
    background: "/static/img/brands/upm/background.jpg",
    emailContacto: "coie.practicas@upm.es",
    footer: {
      es: {
        textos: [
          "Universidad Politécnica de Madrid © 2023"
          // "Campus de Villanueva de la Cañada. Avd. Universidad, 1 Madrid. Teléfono 91 810 93 00"
        ],
        links: {
          "Aviso Legal": "https://www.upm.es/AvisoLegal",
          "Política de Cookies": "https://www.upm.es/AvisoLegal  ",
          "Política de protección de datos personales":
            "/recursosCliente/UPM/Documentos/POLITICA_PRIVACIDAD_UPM.pdf"
        }
      }
    },

    fonts: {
      link: "family=Lato:400,500,700",
      principal: "'Lato', sans-serif",
      secundaria: "'Lato', sans-serif"
    },

    logintexts: {
      es: {
        antiguos: "Antiguos Alumnos",
        estudiantes: "Estudiantes",
        empresas: "Empresas"
      }
    },
    canCambiarPracticas: true,
    //CV DEL USUARIO
    quitarCampoDiscapacidad: true,

    //REGISTRO DE LAS EMPRESAS
    requestStartUp: false,
    requestTipoEmpresa: true,
    requestTipoContacto: true,
    hideRequestFirmanteRegistro: false,
    requestPerfilSectorial: false,
    requestGastosGestionPracticasExtracurriculares: true,
    requestDireccionFullContactoEmpresa: true,
    requestDireccionContactoEmpresa: true,
    checkDatosCompletosEmpresa: true,
    infoRGDP: true,
    representanteLegalEmpresa: false,
    registroEmpresas: {
      sede: {
        visible: false,
        required: false
      },
      dni: {
        visible: true,
        required: true
      },
      numeroempleados: {
        visible: true,
        required: false
      },
      otrosector: {
        visible: false,
        required: false
      },

      edicionimagen: {
        visible: true
      },
      centroTrabajoAdicional: {
        visible: true,
        required: true
      }
    },
    miEmpresa: {
      centroTrabajo: {
        annadir: true,
        editar: true
      },
      canBorrarCuenta: true
    },
    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración"
        },
        showIn: [],
        required: true
      },
      ayudaEstudio: {
        label: {
          es: "Ayuda al estudio (€ brutos/mes)"
        },
        showIn: ["Practicas"]
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*"
          },
          Practicas: {
            es: "Actividades a desarrollar*"
          }
        }
      },
      experiencia: {
        showIn: ["Empleo"]
      },
      motivosexclusion: {
        showIn: []
      },
      tipoContrato: {
        showIn: ["Empleo", "Practicas"]
      },
      requisitosfromcv: false
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true
      },
      tareasDesarrollar: {
        label: "Actividades a desarrollar",
        required: true
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false
      },
      ayudaEstudio: {
        label: "Ayuda al estudio (€ brutos/mes)"
      },
      tutorEmpresa: {
        titulacion: true
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada"
        },
        showIn: ["Practicas"]
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: true
    },
    requestDatosTutorEnOferta: true,
    requestDatosContactoTipoOfertas: true,
    requestTutoresPractica: true,
    academicos: {
      calificacion: {
        editable: true
      },
      centro: {
        editable: true
      }
    },

    personales: {
      imagen: {
        visible: true,
        editable: true
      },
      email: {
        visible: true,
        editable: false
      },
      emailestudiante: {
        visible: true,
        editable: false
      },
      telefono: {
        visible: true,
        editable: false
      },
      email: {
        visible: true,
        editable: true
      },
      emailComunicaciones: {
        visible: true,
        editable: true
      },
      permisotrabajo: {
        visible: true,
        editable: true
      },
      fecha_nacimiento: {
        visible: true,
        editable: false
      },
      direcciones: {
        "1": {
          visible: true,
          editable: true,
          hide: ["tipovia", "piso", "numero", "puerta"],
          nombre: {
            es: "Dirección actual"
          }
        },
        "2": {
          visible: true,
          editable: false,
          hide: ["tipovia", "piso", "numero", "puerta"],
          nombre: {
            es: "Dirección"
          }
        }
      },
      direccionsimple: {
        visible: false,
        editable: false
      },
      numeroSeguridadSocial: {
        visible: true,
        editable: true
      }
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required"
      },
      sector: {
        editable: true,
        validate: "required"
      },
      empresa: {
        editable: true,
        validate: "required"
      },
      provincia: {
        editable: true,
        validate: "required"
      },
      duracion: {
        editable: true,
        validate: "required"
      }
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false
      },
      permisoTrabajo: {
        editable: false,
        visible: false
      },
      retribucion: {
        editable: false,
        visible: false
      }
    },
    otros_intereses: {
      visible: false
    },
    interes: {},

    ownlogin: {
      hasEstudiante: true,
      hasEgresado: false,
      textoEstudiantes: {
        es:
          "Los estudiantes de UPM disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
      },
      textoEgresados: {
        es:
          "Los egresados de UPM disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
      },
      textoTutores: {
        es:
          "Los tutores de UPM disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
      }
    },
    //DOCUMENTACION
    canSubirConvenios: false,
    tituloConvenios: "Convenios de Cooperación Educativa",
    canCrearConvenios: true,
    hasNotasFormativas: false,
    mensajeconveniogenerado: {
      titulo:
        "Su solicitud se ha recibido correctamente.",
      mensaje: "La tramitaremos en el menor tiempo posible.",
      to: "/documentacion"
    },
    mensajeconveniosubido: {
      titulo: "Convenio añadido correctamente",
      mensaje:
        "Cuando la Universidad haya firmado el Convenio le enviaremos copia final. La tramitación de Anexos de prácticas requiere que se haya completado el proceso de firma por lo que hasta ese momento ningún alumno debe incorporarse en prácticas a la empresa. Si tiene cualquier duda puede contactar en practicas@fund.uc3m.es o en 916249902"
    },
    //BAJA EMPRESA
    mensajeBaja: {
      titulo:
        "Hemos recibido su solicitud y la tramitaremos en el menor tiempo posible.",
      mensaje: "",
      to: "/"
    },
    empresaSinConvenio: {
      titulo: "Atención",
      mensaje:
        "Su entidad no cuenta con un convenio formalizado con Universidad Politécnica de Madrid, por lo que no podrá acceder a la gestión de prácticas hasta que éste no esté en vigor.",
      to: "/documentacion"
    },
    //SETEO
    showPropuestaPracticas: true,
    hideCamposTutor: [],
    requisitosObligatoriosOferta: false,
    siteAlumnos: {
      showPropuestaPracticas: false,
      showDarDeBaja: true
    },
    siteEmpresa: {
      showPropuestaPracticas: true
    },
    titulacionesRequeridasOfertaByDropdown: true,
    OneLoginForCandidatos: true,
    maxLengthEncuestas: 6000,
    hasSeguroPracticas: true
  }
};


// WEBPACK FOOTER //
// ./src/brands/brands.js